import React, { HTMLAttributes } from "react";
import { ChevronDown } from "../../../assets/svg/icons";

interface DropdownProps {
  options: string[];
  onSelect: (option: string) => void;
  placeholder?: string;
  selectedOption?: string;
  props?: HTMLAttributes<HTMLSelectElement>;
  container?: HTMLAttributes<HTMLDivElement>;
}

const Dropdown: React.FC<DropdownProps> = ({
  options,
  selectedOption,
  onSelect,
  placeholder,
  props,
  container,
}) => {
  const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = e.target.value;
    onSelect(selectedValue);
  };

  if (!options || options.length === 0) {
    return null;
  }

  return (
    <div className={"vcl-dropdown-container"} {...container}>
      <select
        {...props}
        value={selectedOption ?? ""}
        className={"vcl-dropdown"}
        onChange={handleSelect}
      >
        <option value={""} hidden>
          {placeholder ?? "Select an option"}
        </option>
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
      <div className={"vcl-dropdown-icon-spacer"} />
      <div className={"vcl-dropdown-icon"}>
        <ChevronDown color={"#ACACAC"} />
      </div>
    </div>
  );
};

export default Dropdown;
